import { capitalize } from 'lodash'

/**
 * Map EPS WEX merged timeline row to the Marqeta VCN-service transaction row shape
 * used by TransactionModal / TransactionRow.
 *
 * @param {object} item merged WEX row from EPS
 */
export function mapWexMergedToVcTransactionRow(item) {
  const stableId =
    item.id != null && item.id !== ''
      ? item.id
      : `generated:${item.kind}:${item.occurredAt ?? ''}:${String(
          item.amount ?? ''
        )}:${item.type ?? ''}`
  return {
    payment_transaction_id: `wex:${stableId}`,
    transaction_date: item.occurredAt || '1970-01-01T00:00:00.000Z',
    transaction_amount: item.amount == null ? 0 : item.amount,
    status: item.status || '',
    type: item.type || item.kind || '',
    source: 'WEX',
    vcn_card: item.vcn_card || '',
  }
}

export function mapAchIstreamToVcTransactionRow(item) {
  return {
    payment_transaction_id: `ach:${item.id}`,
    transaction_date: item.transactionDate || '1970-01-01T00:00:00.000Z',
    transaction_amount:
      item.transactionAmountCents == null
        ? 0
        : Number(item.transactionAmountCents) / 100,
    status: capitalize(item.transactionStatus) || '',
    type: item.transactionType || '',
    source: 'ACH',
    vcn_card: '',
  }
}

/**
 * @param {unknown[]} marqetaList
 * @param {object[] | undefined} wexMergedList
 */
export function combineAndSortTransactions(marqetaRes, wexRes, achRes = []) {
  const marqetaRows = marqetaRes?.transactions ?? []
  const wexRows =
    wexRes?.mergedTransactions?.map(mapWexMergedToVcTransactionRow) ?? []
  const achRows = achRes?.map(mapAchIstreamToVcTransactionRow) ?? []

  marqetaRows.forEach((transaction) => {
    transaction.source = 'MARQETA'
    transaction.vcn_card =
      'MARQETA ' + (marqetaRes?.card_source_link?.last4 ?? '')
  })
  wexRows.forEach((transaction) => {
    transaction.vcn_card = 'WEX ' + (wexRes?.last4 ?? '')
  })
  return [...marqetaRows, ...wexRows, ...achRows].sort((a, b) => {
    const ta = Date.parse(a.transaction_date) || 0
    const tb = Date.parse(b.transaction_date) || 0
    return tb - ta
  })
}
